import styles from "../assets/styles/AskStarLoading.module.css";

export default function AskStarLoading() {
  return (
    <div className={styles.spinner}>
      <div className={styles.circle}>
        <div className={styles.element}></div>
        <div className={styles.element}></div>
        <div className={styles.element}></div>
      </div>

      <div className={styles.warning}>
        별들로부터 수신 중.. <br />
        페이지를 나가거나 닫지 마세요
      </div>
    </div>
  );
}
